import { memo } from 'react';

import { Button } from '@air/primitive-button';

import { useSharePrivateCollectionModal } from '~/components/SharePrivateCollectionModal/SharePrivateCollectionModalContext';

export const ModalActionButtons = memo(() => {
  const { onSave, onClose, isSaving, errors, hasCreatedShareLink } = useSharePrivateCollectionModal();

  return (
    <div className="flex justify-end gap-2 px-8">
      {hasCreatedShareLink ? (
        <Button appearance="filled" color="blue" size="large" type="button" onClick={onClose}>
          Done
        </Button>
      ) : (
        <>
          <Button appearance="ghost" color="grey" size="large" type="button" onClick={onClose} disabled={isSaving}>
            Cancel
          </Button>
          <Button
            appearance="filled"
            color="blue"
            size="large"
            type="submit"
            onClick={onSave}
            disabled={isSaving || !!errors}
            isLoading={isSaving}
          >
            Create link
          </Button>
        </>
      )}
    </div>
  );
});

ModalActionButtons.displayName = 'ModalActionButtons';
